<template>
  <div>
    <o-section :overlay="true">
      <p>
        De kostprijs van je rit wordt mee bepaald door het aantal gereden
        kilometers. Geef hieronder aan hoe ver je denkt te zullen rijden.
      </p>
    </o-section>
    <o-section :overlay="true">
      <o-text-input label="Geschatte afstand (in kilometer)">
        <o-text-input value="20" inputmode="numeric" class="u-flex__flexible" />
        <o-button
          label="Bereken"
          size="small"
          :is-primary="true"
          @click="cost = '€ 35,12'"
        />
      </o-text-input>
    </o-section>
    <o-section :overlay="true" :borderless="true" :primary="true">
      <o-text-input
        label="Geschatte prijs"
        :primary="true"
        :value="cost"
        :readonly="true"
      />
    </o-section>
    <o-section :overlay="true">
      <p class="u-muted u-small">
        Heb je nog vragen over de prijszetting bij Cambio?<br />Bekijk
        <a href="#">hier</a> meer info.
      </p>
    </o-section>
  </div>
</template>

<script>
import OTextInput from '@/components/base/OTextInput.vue'
import OButton from '@/components/base/OButton.vue'
export default {
  name: 'OCostEstimate',
  components: { OButton, OTextInput },
  data: () => ({
    cost: '—'
  })
}
</script>
